import { useNavigate, useSearchParams } from 'react-router-dom';
import { ChevronRightIcon, Footer, TitleBar } from '../../../components';
import TitleUpdater from '../../../components/common/TitleUpdater';
import { useLocationName } from '../../../hooks';
import TableV3 from '../../../components/generic/Table/TableV3';
import { COLUMN_WIDTHS, columns } from '../columns/it-applications-columns';
import { useItApplicationMetrics } from '../hooks/useItApplicationMetrics';
import { useState } from 'react';
import { ApplicationFilters } from '../components/ApplicationFilters';
import { APPLICATION_TYPES } from '../../cyber/constants';
import { Button, TableColumnsType } from 'antd';
import { CyberHubItApplicationMetricsData } from '../types/it-applications';

export const CyberHubItApplications = () => {
  let [searchParams] = useSearchParams();
  const locationId = searchParams.get('locationId')!;

  const { locationName } = useLocationName(locationId);

  const { data: itApplications, loading } = useItApplicationMetrics(
    locationId,
    {
      includeUnmapped: true,
    },
  );

  const navigate = useNavigate();

  const applicationColumns: TableColumnsType<CyberHubItApplicationMetricsData> =
    [
      ...columns,
      {
        title: '',
        dataIndex: 'arrowLink',
        key: 'arrowLink',
        width: COLUMN_WIDTHS.ARROW_LINK,
        align: 'center',
        render: (_, record) => {
          if (record.unmapped) {
            return null;
          }

          return (
            <Button
              type="link"
              size="small"
              onClick={() =>
                navigate(
                  `/cyber-hub/it-applications/${record.uuid}/report${
                    locationId ? `?locationId=${locationId}` : ''
                  }`,
                )
              }
            >
              <ChevronRightIcon
                width={8}
                height={14}
                className="fill-black hover:!fill-black group-hover:opacity-50 disabled:group-hover:opacity-100"
              />
            </Button>
          );
        },
      },
    ];

  const [filters, setFilters] = useState({
    applicationType: null as
      | (typeof APPLICATION_TYPES)[keyof typeof APPLICATION_TYPES]
      | null,
    selectedTierUuid: null as string | null,
    drpInPlace: null as boolean | null,
  });

  const filteredData = itApplications?.filter((item) => {
    if (
      filters.applicationType &&
      item.applicationType !== filters.applicationType
    )
      return false;
    if (
      filters.selectedTierUuid &&
      item.tier?.uuid !== filters.selectedTierUuid
    )
      return false;
    if (filters.drpInPlace !== null && item.drpInPlace !== filters.drpInPlace)
      return false;
    return true;
  });

  const pageTitle = locationName
    ? `${locationName} - It Applications`
    : 'Enterprise It Applications';

  const title = 'Applications';

  const subtitle = locationName
    ? locationName
    : 'Enterprise Level Applications';

  return (
    <div>
      <TitleUpdater title={pageTitle} />
      <TitleBar title={title} subtitle={subtitle} />
      <ApplicationFilters
        locationName={locationName}
        onFiltersChange={setFilters}
      />
      <TableV3
        title={`${filteredData?.length || 0} Applications`}
        data={filteredData}
        columns={applicationColumns}
        loading={loading}
        pageSize={25}
      />
      <Footer goBack />
    </div>
  );
};
